const swiper = new Swiper(".featured-patrimony__slider", {
    slidesPerView: 1,
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
});